<template>
  <div class="html">
    <banner
      :title="title"
      :content="content"
    />
    <div class="introduces1">
      <p class="sub_title">
        服务流程
      </p>
      <div class="lists">
        <div
          v-for="(item, index) in processList"
          :key="index"
          class="list_T"
        >
          <div class="item_list1">
            <div class="content">
              <div
                class="con_left1"
                :style="{ background: item.color }"
              >
                <div>
                  <div>0{{ index + 1 }}</div>
                </div>
              </div>
              <div class="con_right1">
                <div class="title">
                  {{ item.title }}
                </div>
                <div class="content_right_item">
                  <div v-if="item.content">
                    {{ item.content }}
                  </div>
                  <div
                    v-for="list in item.list"
                    :key="list"
                  >
                    <li>{{ list }}</li>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="icon-sanjiao1">
          <div class="icon iconfont icon-sanjiao" />
        </div>
        <div class="icon-sanjiao2">
          <div class="icon iconfont icon-sanjiao" />
        </div>
        <div class="icon-sanjiao3">
          <div class="icon iconfont icon-sanjiao" />
        </div>
      </div>
    </div>
    <div class="procedure">
      <p class="sub_title">
        应急预案
      </p>
      <div class="lct">
        <img
          src="@/assets/securityServices/emergency4.png"
          alt=""
        >
      </div>
    </div>
    <div class="introduces">
      <p class="sub_title">
        服务价值
      </p>
      <div class="lists">
        <div
          v-for="item in worthList"
          :key="item.id"
          class="list"
        >
          <div class="item_list">
            <div class="img">
              <img
                :src="item.img"
                alt=""
              >
            </div>
            <div class="content">
              <div
                v-for="list in item.list"
                :key="list"
              >
                {{ list }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/securityServices/components/banner.vue'
export default {
  name: 'Emergency',
  components: {
    banner
  },
  data() {
    return {
      title: '应急响应服务',
      content:
        '在发生信息破坏事件（篡改、 泄露等）、 大规模病毒事件、 Web网站漏洞事件等相关的信息安全事件时， 为客户提供应急响应专家协助处置突发安全事件， 保障涉事单位的正常运营、 减少因安全事件为单位带来的经济损失和负面影响的服务。',
      worthList: [
        {
          id: 1,
          img: require('@/assets/securityServices/emergency1.png'),
          list: ['有效降低安全事件的影响程度，快速恢复业务正常']
        },
        {
          id: 2,
          img: require('@/assets/securityServices/emergency2.png'),
          list: ['建立有效的协同防御机制，增强业务系统的防护能力']
        },
        {
          id: 3,
          img: require('@/assets/securityServices/emergency3.png'),
          list: ['降低安全运营成本提高单位信息业务发展安全竞争力']
        }
      ],

      processList: [
        {
          id: 1,
          title: '准备阶段',
          color: '#5782E3',
          content:
            '保证在发生信息安全事件后能顺利完成应急响应工作而必须在日常完成的准备工作。',
          list: ['人力资料准备', '应急工具准备', '安全资料准备']
        },
        {
          id: 2,
          title: '研判阶段',
          color: '#82B3EF',
          content:
            '针对事件类型、危害程度、利用门槛、传播特征、影响范围做出研判。针对大面积感染、危害程度严重、具有快速传播类事件应第一时间将事件上升至安服研判组，启动专家研判机制。',
          list: []
        },
        {
          id: 3,
          title: '抑制阶段',
          color: '#83A8F0',
          content:
            '针对已发生事件，可直接使用已有操作手册、专杀工具对事件进行处置。针对新型安全事件，如病毒木马类，需及时反馈病毒样本、现场感染态势，启动应急响应机制，多部门协同处置。将处置结果及安全建议及时反馈客户。',
          list: []
        },
        {
          id: 4,
          title: '根除恢复阶段',
          color: '#929AD3',
          content:
            '彻底根除恢复，协助客户改进网络安全方面不足，帮助客户规划后续网络安全建设方案，为客户打造完善的网络环境，避免安全事故再次发生。',
          list: []
        }
      ]
    }
  }
}
</script>
<style scoped>
@import '../../styles/utils.scss';
</style>
<style lang="less" scoped>
.introduces {
  width: 100%;
  margin: 66px auto 74px;

  .title {
    width: 80%;
    margin: 0 auto;
    font-size: 20px;
  }

  .lists {
    width: 70%;
    margin: 0 auto;
    margin-top: 66px;
    display: flex;
    justify-content: space-between;

    .list {
      width: 28%;
      margin-top: 30px;
      margin: 0 1%;
      background: #fff;
      border-radius: 30px;
      box-shadow: 0 0 50px #ddefff;

      .item_list {
        width: 100%;

        .img {
          text-align: center;
          padding-top: 88px;

          img {
            width: 175px;
            height: auto;
          }
        }

        .content {
          width: 80%;
          margin: 89px auto 133px;

          div {
            text-align: center;
            font-size: 24px;
            font-weight: 400;
            color: #666666;
            line-height: 40px;
          }
        }
      }
    }
  }

  .height {
    min-height: 500px;
  }

  .process {
    width: 70%;
    margin: 93px auto 0;
    background: linear-gradient(to top, #d7e7fc, #d7e7fc);
    padding: 80px 0;

    .address {
      width: 100%;

      .lists {
        width: 90%;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;

        .a1 {
          border-top-left-radius: 20px !important;
        }

        .a5 {
          border-top-right-radius: 20px !important;
        }

        .list {
          width: 18%;
          margin: 0 1%;
          background-color: #ffffff;
          border-radius: 4px;

          .item_list {
            width: 100%;

            .img {
              text-align: center;

              img {
                width: 90px;
                height: 90px;
              }
            }

            .title {
              text-align: center;
              font-size: 24px;
              color: #333333;
              font-weight: bold;
              margin-top: 45px;
              line-height: 40px;
            }

            .content {
              margin: 51px auto;
              width: 70%;
              font-size: 20px;
              font-weight: 400;
              color: #666666;
              line-height: 40px;
            }
          }
        }
      }
    }
  }
}

.introduces1 {
  width: 100%;
  margin: 82px auto;

  .title {
    width: 80%;
    margin: 0 auto;
    font-size: 20px;
  }

  .lists {
    width: 70%;
    margin: 0 auto;
    margin-top: 66px;
    display: flex;
    justify-content: space-between;
    position: relative;

    .icon-sanjiao {
      font-size: 36px;
      color: #83d4de;
    }

    .icon-sanjiao1 {
      position: absolute;
      top: 47%;
      left: 23.6%;
    }

    .icon-sanjiao2 {
      position: absolute;
      top: 47%;
      left: 48.6%;
    }

    .icon-sanjiao3 {
      position: absolute;
      top: 47%;
      right: 23.6%;
    }

    .list_T {
      width: 30%;
      margin-top: 30px;
      margin: 0 1%;
      background: #fff;
      box-shadow: 0 0 50px #ddefff;
      border-radius: 4px;

      .item_list1 {
        width: 100%;

        .content {
          width: 100%;
          display: flex;
          justify-content: space-between;
          min-height: 635px;

          .con_left1 {
            width: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #5782e3;
            border-radius: 4px 0px 0px 4px;

            font-size: 24px;
            font-weight: bold;
            color: #ffffff;
            line-height: 40px;
          }

          .con_right1 {
            width: calc(100% - 48px);
            margin-top: 20px;

            .title {
              margin-top: 45px;
              text-align: center;
              font-size: 24px;
              font-weight: bold;
              color: #333333;
              line-height: 40px;
            }

            .content_right_item {
              text-align: left;
              margin: 80px 10% 0;

              font-size: 22px;
              font-weight: 400;
              color: #333333;
              line-height: 30px;
            }
          }
        }
      }
    }
  }
}

.bg_color {
  background: #fafbff;
  padding: 68px 0 104px;
}

@media (min-width: 1200px)and (max-width: 1350px) {
  .introduces1 .sub_title {
    font-size: 35px;
  }

  .introduces1 .lists .list_T .item_list1 .content .con_right1 .content_right_item {
    font-size: 18px;
  }

  .introduces .lists .list .item_list .content div {
    font-size: 20px;
  }
}

@media screen and (min-width: 1350px) and (max-width: 1500px) {
  .introduces1 .lists .list_T .item_list1 .content .con_right1 .content_right_item {
    font-size: 20px;
  }

  .introduces1 .sub_title {
    font-size: 35px;
  }
  .introduces .lists .list .item_list .content div{
    font-size: 22px;
  }
}
</style>
